const unsplash = (id, w = 1200) =>
  `https://images.unsplash.com/photo-${id}?auto=format&fit=crop&w=${w}&q=70`;

export const SITE_IMAGES = {
  careLibraryHero: unsplash("1466692476868-aef1dfb1e735", 1400),
  visitGlasshouse: unsplash("1466692476868-aef1dfb1e735", 1200),
  giftCard: unsplash("1513885535751-8b9238bd345a", 1000),
  plantShelf: unsplash("1525498128493-380d1990a112", 1200),
  shopHero: unsplash("1614594975525-e45190c55d0b", 1200),
  journalHero: unsplash("1416879595882-3373a0480b5b", 1200),
  packing: unsplash("1673573036163-a27b9a420dc5", 1000),
  delivery: unsplash("1666986434665-e2f7ce65a43d", 1000),
  collection: unsplash("1466692476868-aef1dfb1e735", 1000),
  advice: unsplash("1620741475287-bc63efcadca6", 1000),
  account: unsplash("1545241047-6083a3684587", 1000),
  emptyState: unsplash("1525498128493-380d1990a112", 1000),
  aboutNiche: unsplash("1685721269025-d70a32c5bcd9", 1000),
  aboutClimate: unsplash("1758702160898-6f96d1db5b73", 1000),
  aboutPacked: unsplash("1673573036163-a27b9a420dc5", 1000),
};
